// Read a single query-string parameter off the current URL.
// Shared by ExperiencePage, its LoaderOverlay and ProjectPage so all three agree
// on how the ?msg1/?build/?ver style parameters are parsed, and so the overlay
// does not have to import the page back.
export function getQuery(key, def = "") {
  const u = new URL(window.location.href);
  return u.searchParams.get(key) || def;
}
